import { render, staticRenderFns } from "./CandidateItemFields.vue?vue&type=template&id=0e98c8b1&scoped=true&lang=pug"
import script from "./CandidateItemFields.vue?vue&type=script&lang=js"
export * from "./CandidateItemFields.vue?vue&type=script&lang=js"
import style0 from "./CandidateItemFields.vue?vue&type=style&index=0&id=0e98c8b1&prod&lang=scss"
import style1 from "./CandidateItemFields.vue?vue&type=style&index=1&id=0e98c8b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e98c8b1",
  null
  
)

export default component.exports